import { render, staticRenderFns } from "./news_all_tags.vue?vue&type=template&id=1cbaeb56"
import script from "./news_all_tags.vue?vue&type=script&lang=js"
export * from "./news_all_tags.vue?vue&type=script&lang=js"
import style0 from "./news_all_tags.vue?vue&type=style&index=0&id=1cbaeb56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports